import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useDarkMode from 'hooks/useDarkMode';
import services from 'services';
import { convertDarkModeStrToSelectedDarkMode } from 'utils';

import MobileRadioGroupPreference from '../MobileRadioGroupPreference/MobileRadioGroupPreference';

const MobileDarkModeSelector = () => {
  const { t } = useTranslation();
  const { selectedDarkMode, darkModeAllowed } = useDarkMode();

  const handleDarkModeChange = useCallback((event) => {
    services.appFrame.theme.setDarkModeSelection(convertDarkModeStrToSelectedDarkMode(event.target.value));
  }, []);

  const items = useMemo(
    () => [
      {
        value: 'auto',
        label: t('theme.auto'),
        disabled: !darkModeAllowed,
      },
      {
        value: 'false',
        label: t('theme.light'),
      },
      {
        value: 'true',
        label: t('theme.dark'),
        disabled: !darkModeAllowed,
      },
    ],
    [darkModeAllowed, t],
  );

  return (
    <MobileRadioGroupPreference
      data-testid="MobileDarkModeSelector-root"
      title={t('mobileNavigation.appearance')}
      value={selectedDarkMode as string}
      items={items}
      onChange={handleDarkModeChange}
    />
  );
};

export default MobileDarkModeSelector;
